import React, { useRef, useState } from 'react';
import * as R from "ramda";
import { useDispatch } from 'react-redux';

import contriesList from 'iso-3166-1-alpha-2';
import countryTelData from 'country-telephone-data';
import parsePhoneNumber from 'libphonenumber-js';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { updateUserSecurity } from '../../actions/partner/partner';
import { isValidEmail } from '../../utils/misc';

export const DonnesProfile = ({ selectedProfile, setSelectedProfile, selectProfileCopy }) => {

	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const dispatch = useDispatch();

	const DonnesProfile = useRef();
	const buttonRef = useRef();
	//const [selectedProfile, setSelectedProfile] = useState({ email: "", phoneNumber: "", countryCode: "" });

	function handleSubmit(e) {
		e.preventDefault();
		DonnesProfile.current.classList.add("was-validated");

		if (DonnesProfile.current.checkValidity()) {

			const phoneNumber = selectedProfile.phoneNumber?.includes("+") ? "+" + selectedProfile.countryCode + parsePhoneNumber(selectedProfile.phoneNumber).nationalNumber.replace(/ /g, '') : "+" + selectedProfile.countryCode + selectedProfile.phoneNumber?.replace(/ /g, '');

			if (selectProfileCopy.phoneNumber !== selectedProfile.phoneNumber) {
				dispatch(updateUserSecurity(selectedProfile.id, { newPhoneNumber: phoneNumber }));
			}

			if (selectProfileCopy.email !== selectedProfile.email) {
				dispatch(updateUserSecurity(selectedProfile.id, { newEmail: selectedProfile.email }));

			}

			buttonRef.current.setAttribute("data-dismiss", "modal");
			buttonRef.current.click();
		}

		buttonRef.current.removeAttribute("data-dismiss");
	}

	return (
		<div className="modal fade px-0" id="DonnesProfile" aria-labelledby="DonnesProfileLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-secondary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">User Account Donnes</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-secondary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="DonnesProfileLabel">
									Données du compte utilisateur
								</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default py-0">
						<p className="h5 lh-copy mb-sm">
							Consultez et modifiez ci-dessous les détails du compte <strong>{selectedProfile?.name}</strong> en conséquence.
						</p>
						<section className="card card-body bg-light rounded">
							<form className="form" noValidate id="useraccountForm" ref={DonnesProfile} onSubmit={handleSubmit}>
								<div className="form-group container-copy">
									<label className="h6 font-weight-bolder lh-root" htmlFor="telephone">
										Numéro de téléphone de l'utilisateur
									</label>
									<div className="input-group mb-0">
										{/* <select className="custom-select rounded container-paper container-sm-tiny mr-2" id="naturalite" tabIndex={-98} value={selectedProfile.country} onChange={(e) => setSelectedProfile({ ...selectedProfile, country: e.target.value })}> */}
										{/* <option key={"index"} value={'+'}>{'countries.getName(country, "fr", { select: "official" })'} (+{'dialCode'})</option> */}
										{/* <option value={'+'}>{countries.getName(country, "fr", { select: "official" })}</option> */}
										{/* {
														Object.keys(contriesList.getData()).map((country, index) => {
															return (
																<option key={index} value={country}>{countries.getName(country, "fr", { select: "official" })}</option>
															);
														})
													} */}
										{/* </select> */}
										<select
											className="custom-select rounded container-tiny mr-2"
											id={"phonecode"}
											tabIndex={-98}
											value={selectedProfile.countryCode}
											onChange={(event) => {
												let pc = countryTelData.allCountryCodes[event.target.value][0].toUpperCase();
												setSelectedProfile({ ...selectedProfile, countryCode: event.target.value, phoneCountry: pc });
											}}>
											{Object.keys(contriesList.getData()).map((country, index) => {
												let dialCode = countryTelData.allCountries[countryTelData.iso2Lookup[country.toLowerCase()]].dialCode;

												return (
													<option key={index} value={dialCode}>
														{countries.getName(country, "fr", { select: "official" })} (+{dialCode})
													</option>
												);
											})}
										</select>
										<input
											required={R.isNil(selectedProfile.userName) || !isValidEmail(selectedProfile.userName)}
											type="tel"
											className="form-control rounded"
											id={"phone"}
											placeholder="00 00 00 00 00"
											value={R.isNil(selectedProfile.phoneNumber) ? "" : parsePhoneNumber(selectedProfile.phoneNumber, selectedProfile.phoneCountry) !== undefined ? parsePhoneNumber(selectedProfile.phoneNumber, selectedProfile.phoneCountry).formatNational() : selectedProfile.phoneNumber}
											aria-describedby="telephoneHelpBlock"
											onChange={(e) => {
												const phoneInput = document.getElementById("phone");
												const parsedPhoneNumber = parsePhoneNumber("+" + selectedProfile.countryCode + e.target.value);
												if (R.isNil(parsedPhoneNumber) || !isValidPhoneNumber(parsedPhoneNumber.number)) {
													phoneInput.setCustomValidity("Numéro de télephone invalide.");
												} else {
													phoneInput.setCustomValidity("");
												}

												setSelectedProfile({ ...selectedProfile, phoneNumber: e.target.value });
											}}
										/>
										{/* <input required type="tel" className="form-control rounded" id="telephone" placeholder="00 00 00 00 00" value={selectedProfile.phoneNumber} onChange={(e) => setSelectedProfile({ ...selectedProfile, phoneNumber: e.target.value })} /> */}
										<div className="w-100 mb-1 d-md-none"></div>
										{/* <span className="input-group-text p-0 ml-md-1 border-none"><button className="btn btn-info rounded-inherit px-sm" >Envoyer code</button></span> */}
										<div className="invalid-feedback alert bg-alert-danger mt-2 mb-4">
											<i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
											<span className="align-middle text-dark o-70">Valider votre numéro de téléphone</span>
										</div>
									</div>
									<p className="form-text small text-gray mt-2" id="telephoneHelpBlock">
										<i className="eva eva-info-outline text-info mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle">Nous utiliserons ce numéro pour assurer la sécurité de votre compte.</span>
									</p>
								</div>
								<div className="form-group">
									<label className="h6 font-weight-bolder" htmlFor="email">
										Utilisateur e-mail
									</label>
									<input type="email" className="form-control" id="email" placeholder="votreemail@mail.fr" value={selectedProfile.email} onChange={(e) => setSelectedProfile({ ...selectedProfile, email: e.target.value })} required pattern="^[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,4}$" />
									<div className={"invalid-feedback"}>Champs invalide</div>
								</div>
								<div className="form-group">
									<label className="h6 font-weight-bolder" htmlFor="email">
										Email de réception
									</label>
									<input type="email" className="form-control" id="email" placeholder="votreemail@mail.fr" value={selectedProfile.recipientEmail} disabled required pattern="^[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,4}$" />
									<div className={"invalid-feedback"}>Champs invalide</div>
								</div>
							</form>
						</section>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light" data-dismiss="modal">
							Fermer
						</button>
						<button type="submit" className="btn btn-info border-none" form="useraccountForm" ref={buttonRef}>
							Enregistrer
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};